import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteNewsFeedMutation} from 'api';
import {useSnackbar} from 'notistack';

function NewsFeedDeleteIconButton({newsFeedId}) {
  const [deleteNewsFeed, deleteNewsFeedResult] = useDeleteNewsFeedMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteNewsFeed(newsFeedId).unwrap();
      enqueueSnackbar('NewFeed deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error?.data?.status || undefined;
      enqueueSnackbar(message || `Error deleting NewFeed`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete NewFeed</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this NewFeed?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteNewsFeedResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteNewsFeedResult.isLoading}
            color="error"
            endIcon={deleteNewsFeedResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteNewsFeedResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default NewsFeedDeleteIconButton;
